export const MINIMUM_PASSWORD_LENGTH = 8
